import SteuerruecklagenTemplate from './templates/SteuerruecklagenTemplate';
import { STEUERRUECKLAGEN_CONFIG } from './config/steuerruecklagen';

export default function SteuerruecklagenOesterreich() {
  return <SteuerruecklagenTemplate cfg={STEUERRUECKLAGEN_CONFIG.AT} />;
}
